import React from 'react';

export const QuestionDiscIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="22"
            height="22"
            version="1.1"
            viewBox="0 0 5.821 5.821"
        >
            <g>
                <path
                    fill="#fff"
                    fillOpacity="1"
                    stroke="none"
                    strokeWidth="2"
                    d="M10.95 8A3 3 0 008 11a3 3 0 003 3 3 3 0 003-3 3 3 0 00-3-3 3 3 0 00-.05 0zM11 9.5a1.5 1.5 0 011.5 1.5 1.5 1.5 0 01-1.5 1.5A1.5 1.5 0 019.5 11 1.5 1.5 0 0111 9.5z"
                    transform="scale(.26458)"
                ></path>
                <path
                    fill="#fff"
                    fillOpacity="1"
                    stroke="none"
                    strokeWidth="2"
                    d="M10.98 5a6 6 0 00-.617.033l.158 1.492A4.5 4.5 0 0111 6.5a4.5 4.5 0 014.488 4.178l1.496-.108a6 6 0 00-2.134-4.174A6 6 0 0010.98 5z"
                    transform="scale(.26458)"
                ></path>
                <path
                    fill="#fff"
                    fillOpacity="1"
                    stroke="none"
                    strokeWidth="2"
                    d="M6.932 12.922l-1.358.64a6 6 0 003.852 3.227l.394-1.447a4.5 4.5 0 01-2.888-2.42z"
                    transform="scale(.26458)"
                ></path>
                <path
                    fill="#fefefe"
                    fillOpacity="1"
                    stroke="none"
                    strokeWidth="2"
                    d="M10.99 2a9 9 0 00-2.83.46c.296.417.524.879.65 1.368a7.5 7.5 0 012.153-.328 7.5 7.5 0 01.037 0 7.5 7.5 0 017.5 7.5 7.5 7.5 0 01-7.5 7.5 7.5 7.5 0 01-7.188-5.36H2.26A9 9 0 0011 20a9 9 0 009-9 9 9 0 00-9-9 9 9 0 00-.01 0z"
                    transform="scale(.26458)"
                ></path>
                <g strokeWidth="0.265" transform="translate(.022)">
                    <path
                        d="M1.243 2.43H.804l-.002-.116q0-.214.071-.352.07-.137.282-.31.212-.172.254-.225.063-.085.063-.186 0-.142-.113-.242-.112-.101-.303-.101-.185 0-.309.105t-.17.32l-.445-.055Q.152.96.394.744.64.53 1.034.53q.418 0 .664.219.246.217.246.506 0 .16-.09.304-.09.142-.387.389-.153.127-.19.205-.037.077-.034.277zm-.439.65v-.484h.484v.484z"
                        style={{}}
                        fill="#fff"
                        fillOpacity="1"
                        strokeWidth="0.265"
                        fontFamily="Arial"
                        fontSize="3.528"
                        fontStretch="normal"
                        fontStyle="normal"
                        fontVariant="normal"
                        fontWeight="bold"
                    ></path>
                </g>
            </g>
        </svg>
    );
};
